import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { FormGroup, TextInput, Label, Message } from '@dbk/ui-forms';
import Dropdown from '@dbk/ui-dropdowns';
import Button from '@dbk/ui-buttons';
import { CountryList } from './country-list';
import { ROUTES, HRMW_CONSTANTS, HRMW_DROPDOWN_CONSTANTS } from '../../../constants';
import { checkDuplicateContact } from './mcd-common';
import BlurModal from '../../../../src/components/common/blur-modal';
import '../../../../src/assets/styles/hrmw-mcd.scss';

class AmendContactDetails extends Component {
	constructor(props) {
		super(props);
		this.state=({
			selectedPersonId: '',
			selectedEmail: '',
			isEmailError: false,
			isFaxError: false,
			isFaxNoError: false,
			isPersonError: false,
			isPhoneNoError: false,
			isNewlyAdded: '',
			selectedPhoneCountry: '',
			selectedFaxCountry: '',
			isValidPhoneType: true,
			phoneNo: '',
			phoneType: '',
			showRedirectModal: false,
			countryList: CountryList(),
			mobileNumberTypeValues: HRMW_DROPDOWN_CONSTANTS
		});
	}

	redirectToInitialBpLanding = () => {
		const { paperless: { isEdocumentFlow } } = this.props;
		isEdocumentFlow ? this.props.changePage(ROUTES.PAPERLESS.PAPERLESS_SETTINGS_ROUTE) : this.props.changePage(ROUTES.PROFILE.USER_BP_LIST_ROUTE);
	}
  /* WMCE-27158  Removed filterButton style of buttons */
	// redirect modal content
	redirectModalContent = () => {
		const { i18n: { messages } } = this.props;
		return (
			<div>
				<div className="row small-12 medium-12 large-12 headerMargin">
					{messages['app.manageContactDetails.amendContact.warningMessage']}
				</div>
				<div className="row columns small-12 medium-12 large-12">
					<div className="columns large-2 medium-2 small-12 rightAligned">
						<Button fullWidth size='normal' onClick={this.redirectToInitialBpLanding}>
							{messages['app.common.alert.yes']}
						</Button>
					</div>
					<div className="columns large-2 medium-2 small-12 rightAligned">
						<Button fullWidth tertiary size='normal' onClick={this.hideRedirecteModal} >
							{messages['app.common.alert.no']}
						</Button>
					</div>
				</div>
			</div>
		)
	}

	// Hide redirect modal
	hideRedirecteModal = () => {
		this.setState({showRedirectModal: false});
		this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
	}

	componentWillReceiveProps(nextProps) {

		// if no contact selected, navigated by ack button clicked
		if(!nextProps.hrmw.amendContactDetail.phone &&
			!nextProps.hrmw.amendContactDetail.fax &&
			!nextProps.hrmw.amendContactDetail.emailId) {

				this.setState({showRedirectModal: true});
		}

		// getting Phone No details
		if(nextProps.hrmw.amendContactDetail.phone) {
			this.setState({
				selectedPersonId: nextProps.hrmw.amendContactDetail.person.personId,
				phoneNo: nextProps.hrmw.amendContactDetail.phone.phoneNo,
				phoneType: nextProps.hrmw.amendContactDetail.phone.phoneType,
				selectedPhoneCountry: Number(nextProps.hrmw.amendContactDetail.phone.countryCode),
				isNewlyAdded: nextProps.hrmw.amendContactDetail.isNewlyAdded
			});
		}

		// getting fax details
		if(nextProps.hrmw.amendContactDetail.fax) {
			this.setState({
				selectedPersonId: nextProps.hrmw.amendContactDetail.person.personId,
				selectedFax: nextProps.hrmw.amendContactDetail.fax.phoneNo,
				selectedFaxCountry: Number(nextProps.hrmw.amendContactDetail.fax.countryCode),
				isNewlyAdded: nextProps.hrmw.amendContactDetail.isNewlyAdded
			});
		}

		// getting email details
		if(nextProps.hrmw.amendContactDetail.emailId) {
			this.setState({
				selectedPersonId: nextProps.hrmw.amendContactDetail.person.personId,
				selectedEmail: nextProps.hrmw.amendContactDetail.emailId,
				isNewlyAdded: nextProps.hrmw.amendContactDetail.isNewlyAdded
			});
		}

	}

	cancelContactAmend = async () => {
		await this.props.hrmw.contactToBeAmend('');
		this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
	}

	changePerson = (selectedPerson) => {
		if(selectedPerson) {
			this.setState({
				isPersonError: false
			});
		} else {
			this.setState({ isPersonError: true });
		}
		this.setState({
			selectedPersonId: selectedPerson
		});
	}

	saveEmail = (event) => {
		this.setState({selectedEmail: event.target.value}, () => {
			this.validateEmail();
		});
	}

	saveFax = (event) => {
		this.setState({selectedFax: event.target.value}, () => {
			this.validateFax();
		});
	}

	savePhoneNo = (event) => {
		this.setState({phoneNo: event.target.value}, () => {
			this.validatePhoneNo();
		});
	}

	amendContact = async () => {

		const { i18n: { messages }, hrmw: { amendContactDetail } } = this.props;
		const { isEmailError, isPhoneNoError, isFaxError, selectedPersonId , isPersonError, isNewlyAdded, phoneNo, selectedPhoneCountry, phoneType, selectedFaxCountry, isValidPhoneType} = this.state;
		let amendedContact = {};

		let person = {
			"personId": selectedPersonId
		};

		if(amendContactDetail.emailId) {
			if(!isEmailError) {
				amendedContact.emailId = this.state.selectedEmail;
			}
		}
		if(amendContactDetail.phone) {
			if(!isPhoneNoError) {
				amendedContact.phoneNo = phoneNo;
				amendedContact.countryCode = selectedPhoneCountry;
				amendedContact.phoneType = phoneType;
			}
			if(!isValidPhoneType) {
				return false;
			}
			if(!selectedPhoneCountry) {
				return false;
			}
		}
		if(amendContactDetail.fax) {
			if(!isFaxError) {
				amendedContact.fax = this.state.selectedFax;
				amendedContact.countryCode = selectedFaxCountry;
			}
			if(!selectedFaxCountry) {
				return false;
			}
		}

		if( !isEmailError && !isFaxError && !isPhoneNoError && !isPersonError ) {

			amendedContact.contactId = amendContactDetail.contactId;
			amendedContact.action = amendContactDetail.action;
			amendedContact.person = person;
			if(isNewlyAdded) {
				amendedContact.isNewlyAdded = true;
			}
			amendedContact.amendDetails = true;
			let contactCheckIndex = -1; 
			contactCheckIndex = this.props.hrmw.latestContactDetails.length <= 1  ? contactCheckIndex : checkDuplicateContact(amendedContact, this.props.hrmw.latestContactDetails);
			if(contactCheckIndex == -1) {
				await this.props.hrmw.contactToBeAmend(amendedContact);
				this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
			} else {
				alert(messages['app.manageContactDetails.duplicateValue']);
			}
		}
	}

	validateEmail = () => {
		const emailRegEx = HRMW_CONSTANTS.EMAIL_REGEX;
		const isValid = emailRegEx.test(this.state.selectedEmail);
		if(!isValid) {
			this.setState({isEmailError: true});
		} else {
			this.setState({isEmailError: false});
		}
		
	}

	validateFax = () => {

		const faxRegEx = HRMW_CONSTANTS.FAX_REGEX;
		const isValid = faxRegEx.test(this.state.selectedFax);
		if(!isValid) {
			this.setState({isFaxNoError: true, isFaxError: true});
		} else {
			this.setState({isFaxNoError: false, isFaxError: false});
		}
	}

	validatePhoneNo = () => {
		const { phoneNo } = this.state;
		const phoneNoRegEx = HRMW_CONSTANTS.PHONE_NO_REG_EX;
		const isValid = phoneNoRegEx.test(phoneNo);
		if(!isValid) {
			this.setState({isPhoneNoError: true});
		} else {
			this.setState({isPhoneNoError: false});
		}
	}

	selectPhoneCountry = (countryCode) => {
		this.setState({selectedPhoneCountry: countryCode});
	}

	selectFaxCountry = (faxCountry) => {
		this.setState({selectedFaxCountry: faxCountry});
		if(faxCountry) {
			this.setState({isFaxError: false});
		} else {
			this.setState({ isFaxError: true});
		}
	}

	selectPhoneType = (phoneType) => {
		this.setState({phoneType: phoneType});
		if(phoneType) {
			this.setState({ isValidPhoneType: true});
		} else {
			this.setState({ isValidPhoneType: false});
		}
	}

	render() {

		const { i18n: { messages }, hrmw: { amendContactDetail, contactDetailsPersonData } } = this.props;
		const { isEmailError, isPhoneNoError, isFaxError, selectedPersonId , isPersonError, phoneType, mobileNumberTypeValues, isValidPhoneType, phoneNo, countryList, selectedFaxCountry, showRedirectModal, selectedPhoneCountry} = this.state;
		let personDropdownValues = [];

		// generating user person dropdown data
		_.forEach(contactDetailsPersonData, function(value) {
			let label;
			if(value.name) {
				label = value.name;
			} else {
				label = `${value.firstName} ${value.middleName} ${value.lastName}`;
			}
			personDropdownValues.push({
				value: value.personId,
				label: label
			});
		});

		if( showRedirectModal ) {
			return ( 
				<BlurModal
				visible={true}
				onDone={this.hideRedirecteModal}
				title={messages['app.manageContactDetails.amendContact.warning']}
				size="large"
				>
				{this.redirectModalContent()}
				</BlurModal>
			);
		}

		return (

			<div className="column small-12 medium-12 large-12 large-centered">
				<h1>{messages['app.common.pageTitle.manageContactDetails']}</h1>
				<div className="addContactGrid">
					<div className="small-12 medium-10 large-10 large-centered">
						<h3>{messages['app.manageContactDetails.fillDetailsInstruction']}</h3>
						<div className="headerMargin">
							{ amendContactDetail.emailId && <FormGroup>
								<Label>{messages['app.manageContactDetails.filter.email']}</Label>
								<TextInput
									testID='txt-email-test'
									placeholder={messages['app.manageContactDetails.addContact.emailPlaceholder']}
									type="text"
									value={this.state.selectedEmail}
									onChange={(e) => this.saveEmail(e)}
								/>
								{this.state.isEmailError && (<Message type="error">{messages['app.manageContactDetails.addContact.emailValidation.emailInvalid']}</Message>)}
							</FormGroup>
							}

							{/* UI to show Fax Details. */}
							{ amendContactDetail.fax && <React.Fragment>
								<div className="row">
									<div className="small-12 medium-2 large-2 column"></div>
									<div className="small-12 medium-2 large-2 column zeroLeftPadding leftAligned">
										<Label>{messages['app.manageContactDetails.addContact.fax']}</Label>
									</div>
								</div>
								<div className="row">
									<div className="small-12 medium-5 large-5 column zeroLeftPadding">
										<FormGroup>
											<Dropdown
												className ='dropdownColor'
												fullWidth
												onChange={(e) => this.selectFaxCountry(e)}
												selected = {selectedFaxCountry}
												options={countryList}
											/>
											{!selectedFaxCountry && <Message type="error">{messages['app.payments.dropdown.select']}</Message>}
										</FormGroup>
									</div>
									<div className="small-12 medium-7 large-7 column">
										<FormGroup>
											<TextInput
												testID='txt-email-test'
												placeholder={messages['app.manageContactDetails.addContact.faxPlaceholder']}
												type="text"
												value={this.state.selectedFax}
												onChange={(e) => this.saveFax(e)}
											/>
											{this.state.isFaxNoError && (<Message type="error">{messages['app.manageContactDetails.addContact.faxValidation.faxInvalid']}</Message>)}
										</FormGroup>
									</div>
								</div>
							</React.Fragment>
							}

							{/* UI to show Phone Details Details. */}
							{ amendContactDetail.phone && <FormGroup>
								<Label>{messages['app.manageContactDetails.addContact.phoneNumber']}</Label>
								<div className="small-12 medium-5 large-5 column zeroLeftPadding">
									<Dropdown
										className ='dropdownColor'
										fullWidth
										onChange={(e) => this.selectPhoneCountry(e)}
										selected = {selectedPhoneCountry}
										options={countryList}
									/>
									{!selectedPhoneCountry && <Message type="error">{messages['app.payments.dropdown.select']}</Message>}
								</div>
								<div className="small-12 medium-4 large-4 column zeroLeftPadding">
									<TextInput
										testID='txt-email-test'
										placeholder={messages['app.manageContactDetails.addContact.mobileNumberPlaceholder']}
										type="text"
										value={phoneNo}
										onChange={(e) => this.savePhoneNo(e)}
									/>
									{isPhoneNoError && <Message type="error">{messages['app.manageContactDetails.addContact.phoneValidation.phoneNoInvalid']}</Message>}
								</div>
								<div className="small-12 medium-3 large-3 column zeroRightPadding">
									<Dropdown
										className ='dropdownColor'
										fullWidth
										textID="mobile_type"
										testID='mobile-number-type'
										defaultLabel={messages['app.manageContactDetails.addContact.mobileNumberTyppePlaceholder']}
										onChange={(e) => this.selectPhoneType(e)}
										selected={phoneType}
										options={mobileNumberTypeValues}
									/>
									{!isValidPhoneType && <Message type="error">{messages['app.manageContactDetails.addContact.FixedLineOrMobileText']}</Message>}
								</div>
							</FormGroup>
							}
						</div>
					</div>
					<div className="row headerMargin">
						<div className="small-12 medium-12 large-10 pt-10 large-centered">
							<FormGroup>
								<Label>{messages['app.manageContactDetails.addContact.name']}</Label>
								<Dropdown
									selected={selectedPersonId}
									fullWidth
									textID="person_name"
									testID='dropdown-person-list-test'
									defaultLabel={messages['app.manageContactDetails.addContact.namePlaceholder']}
									className="large-12 medium-12 small-12 full-width dropdownColor"
									size='large'
									options={personDropdownValues}
									onChange={(selectedPerson) => this.changePerson(selectedPerson)}
								/>
								{this.state.isPersonError && (<Message type="error">{messages['app.manageContactDetails.addContact.personValidation.selectPerson']}</Message>)}
							</FormGroup>
						</div>
					</div>
					<div className="row headerMargin">
						<div className="small-12 medium-12 large-10 large-centered">
							<div className="column medium-6 small-6 large-6">
								<Button tertiary className="rightAligned" onClick={this.cancelContactAmend}>{messages['app.manageContactDetails.btn.cancel']}</Button>
							</div>
							<div className="column medium-6 small-6 large-6">
								<Button className="leftAligned" onClick={this.amendContact} disabled={ isEmailError || isFaxError || isPersonError }>
									{messages['app.manageContactDetails.btn.save']}
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default createContainer({
	$queries: {
		i18n: {
			messages: true,
		},
		hrmw: {
			contactToBeAmend: { $call: 'setAmendContactDetail' },
			amendContactDetail: true,
			contactDetailsPersonData: true,
			latestContactDetails: true
		},
		paperless: {
			isEdocumentFlow: true
		}
	},
})(AmendContactDetails);